import { io } from 'socket.io-client';

const url = process.env.REACT_APP_API_SOCKET_URL || 'http://localhost:8002'

export const socket = io(url, {
});